import { render, staticRenderFns } from "./news-expanded.html?vue&type=template&id=add6d712&scoped=true&"
import script from "./news-expanded.js?vue&type=script&lang=js&"
export * from "./news-expanded.js?vue&type=script&lang=js&"
import style0 from "./news-expanded.scss?vue&type=style&index=0&id=add6d712&prod&scoped=true&lang=scss&"
import style1 from "./../monitoring-differential-highlighter/monitoring-differential-highlighter.scss?vue&type=style&index=1&id=add6d712&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add6d712",
  null
  
)

export default component.exports